import React, { useEffect, useState } from "react";
import FeaturedJobs from "./FeaturedJobs";
import "../JobDetails/JobDetails.css";
import { JobSearch, post } from "../../config/imagesLink";
import axios from "../../API/axios";
import { getUserConfig } from "../../Services/apiService";
import { Link, useNavigate, useParams } from "react-router-dom";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import moment from "moment";
import ModalForGuest from "../ModalForGuest";
import { Modal } from "react-bootstrap";
import JobApply from "../JobSearch/JobApply";
import DetailJobApply from "./DetailJobApply";
import BookmarkSharpIcon from "@mui/icons-material/BookmarkSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import { Helmet } from "react-helmet";
import JobApplyModals from "./JobApplyModals";
import { ShimmerDiv } from "@skeleton";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { recordImpressions } from "../../Services/engagementService";
import { getLangKey, getStoredLangCode } from "../../utils/language";
import JobStatusBadges from "../../components/JobStatusBadges";

const JobDetails = ({ setShowjobDetails }) => {
  const { JobId } = useParams();
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const ProfilePercent = localStorage.getItem("ProfilePercentage");
  const { t } = useTranslation();
  const language = getStoredLangCode();
  const [screeningQuestions, setScreeningQuestions] = useState([]);
  const [screeningAnswers, setScreeningAnswers] = useState({});
  const [recommendTree, setRecommendTree] = useState([]);
  const [bookmarkModal, setBookmarkModal] = useState(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };
  const [appliedJobId, setAppliedJobId] = useState(false);
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleCloseModal = () => setShowAppliedModal(false);
  const handleShow = () => setShowAppliedModal(true);
  const userUid = localStorage.getItem("userUid");
  //************************User Profile Stats Start  ************************//
  // const [userPer, setUserPer] = useState([]);
  // const getUserProfilePer = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`UserProfile/GetProfilePercentage`, data)
  //     .then((response) => {
  //       console.log("userprofilestat", response.data.responseData);
  //       const res = response.data.responseData;
  //       setUserPer(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getUserProfilePer();
  // }, [sessionId]);

  //************************User Profile Stats End  ************************//
  const [profileConfig, setProfileConfig] = useState([]);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      setProfileConfig(responseData);
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        setUnauthorisedModal(true);
      }
    }
  };

  const [showResumeModal, setShowResumeModal] = useState(false);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    if (sessionId) {
      (async () => {
        await Promise.all([
          userConfig()
        ]);
      })();
    }
  }, []);

  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const [Loading, setLoading] = useState(true);

  const [jobData, setJobData] = useState("");
  const [jobSkillNames, setJobSkillNames] = useState([]);
  const JobDetails = async () => {
    setLoading(true);
    try {
      await axios
        .get(`Job/GetJobDetails?DeviceType=Web&JobId=${JobId}&langKey=${getLangKey(language)}`)
        .then((resData) => {
          if (resData.status === 204 || resData.status === 400) {
            setErrorImage(true);
            console.log("ssssssss", resData.status);

          } else {
            setLoading(false);

            console.log("resData", resData.data.responseData.viewJob);
            const viewJob = resData.data.responseData.viewJob;
            setJobData(viewJob);
            const skillRows =
              viewJob?.jobSkills ||
              viewJob?.JobSkills ||
              resData.data.responseData.skills ||
              [];
            setJobSkillNames(
              Array.isArray(skillRows)
                ? skillRows.map((s) =>
                    typeof s === "string" ? s : s.name || s.Name || ""
                  ).filter(Boolean)
                : []
            );
            setScreeningQuestions(resData.data.responseData.screeningQuestions || []);
            recordImpressions([{ targetType: 2, targetId: JobId, source: 2 }]);
          }
        });

    } catch (error) {
      setErrorImage(true);

      console.log(error);
    } finally {
      setLoading(false); // ✅ always stop loading
    }
  };

  useEffect(() => {
    JobDetails();
  }, [JobId]);

  useEffect(() => {
    if (!sessionId || guestModeData === "true" || !userUid) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(
          `Match/RecommendTree?DeviceType=Web&EntityType=1&EntityId=${encodeURIComponent(
            userUid
          )}&Take=6&LangKey=${getLangKey(language)}`
        );
        const items =
          res?.data?.responseData || res?.data?.ResponseData || [];
        if (!cancelled && Array.isArray(items)) {
          setRecommendTree(
            items.filter(
              (x) =>
                String(x.entityId ?? x.EntityId) !== String(JobId) &&
                (x.entityType ?? x.EntityType) === 2
            )
          );
        }
      } catch {
        /* additive — FeaturedJobs remains */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [JobId, sessionId, userUid, language, guestModeData]);
  // console.log('jobData', jobData);

  const [savedJobs, setSavedJobs] = useState(new Set());
  // const [jobId, setJobId] = useState('');
  const saveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        console.log("save post", res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(true);
        setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save Post End  ************************//

  //************************UnSave Post start  ************************//
  const unsaveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(false);
        setSavedJobs((prev) => {
          const newSavedJobs = new Set(prev);
          newSavedJobs.delete(jobId);
          return newSavedJobs;
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************UnSave Post End  ************************//
  const now = moment();
  const itemTime = moment.utc(jobData?.creationTime);
  const duration = moment.duration(now.diff(itemTime));

  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  let result = "";

  // if (years > 0) {
  //   result = `${years} year${years > 1 ? "s" : ""} ago`;
  // } else if (months > 0) {
  //   result = `${months} month${months > 1 ? "s" : ""} ago`;
  // } else if (days > 0) {
  //   result = `${days} day${days > 1 ? "s" : ""} ago`;
  // } else if (hours > 0) {
  //   result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
  // } else if (minutes > 0) {
  //   result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  // } else {
  //   result = "just now";
  // }
  if (years > 0) {
    result = `${years} ${t("Notifications.Year")} ${t("Notifications.Ago")}`;
  } else if (months > 0) {
    result = `${months} ${t("Notifications.Month")} ${t("Notifications.Ago")}`;
  } else if (days > 0) {
    result = `${days} ${t("Notifications.Day")} ${t("Notifications.Ago")}`;
  } else if (hours > 0) {
    result = `${hours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`;
  } else if (minutes > 0) {
    result = `${minutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`;
  } else {
    result = t("Notifications.Just Now");
  }


  console.log(result);

  //************************Apply and unapply job  ************************//
  const [showModal, setShowModal] = useState(false);
  const [isappliedF, setIsappliedF] = useState(false);

  const applyNew = async () => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: JobId,
        type: 1,
        userUid: userUid,
        langKey: getLangKey(language),
        screeningAnswers: Object.entries(screeningAnswers)
          .filter(([, text]) => String(text || "").trim())
          .map(([jobSqId, answerText]) => ({
            jobSqId: Number(jobSqId),
            answerText: String(answerText),
          })),
      };
      // console.log('body', body);
      const res = await axios.post("/JobAction/ApplyJob", body);
      setToastMessage(res.data.message);
      setShowToast(true);
      JobDetails();
      // closeModal();
      // setJobList([]);
      // getAllJobList(page);
      // setAppliedId(jobId);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const unapplyNew = async (jobId) => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: JobId,
        type: 1,
        userUid: userUid,
        langKey: language === "en" ? "" : language,
        // hiringStatus: 1,
        // rateType: 1,
        // isRead: true,
      };
      const res = await axios.post("/JobAction/UnApplyJob", body);
      setToastMessage(res.data.message);
      setShowToast(true);
      handleCloseModal();
      JobDetails()
    } catch (e) {
      console.log(e.response.data.message);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Apply and unapply job  ************************//
  console.log("JobSearch", jobData);

  useEffect(() => {
    if (showAppliedModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showAppliedModal]);

  console.log("jobData", jobData);

  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowToolbar(true);
      } else {
        setShowToolbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [jobModalOpen, setJobModalOpen] = useState(false);
  const [jobAction, setJobAction] = useState('')
  const handleJobApply = () => {
    setJobModalOpen(true);
  };

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h[1-6][^>]*>/gi, '<div class="job-short-heading">')
      ?.replace(/<\/h[1-6]>/gi, "</div>")
      ?.replace(/<strong[^>]*>/gi, "")
      ?.replace(/<\/strong>/gi, "")
      ?.replace(/font-size\s*:\s*[^;"']+;?/gi, "")
      ?.replace(/text-align\s*:\s*[^;"']+;?/gi, "")
      ?.replace(/\salign=["'][^"']*["']/gi, "")
      ?.replace(/\sclass=["'][^"']*ql-align[^"']*["']/gi, "");
  };

  return (
    <>
      <Helmet>
        <title>{`${jobData?.title}`} | Welinkjobs</title>
        <meta name="description" content={`${jobData?.fullDescription}`} />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta
          property="og:title"
          content={`${jobData?.title} Profile | Welinkjobs`}
        />
        <meta
          property="og:description"
          content={`${jobData?.fullDescription}`}
        />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
      </Helmet>

      {Loading ? (
        <div className="p-lg-5 p-md-3 p-3 mt-5">
          <div className="row mt-3 jobdetail-sideLinks">
            <div className="col-md-6 jobdetail-left">
              <ShimmerDiv height={580} width={"100%"} />
            </div>
            <div className="col-md-6 jobdetail-right">
              <ShimmerDiv height={200} width={"100%"} />
            </div>
          </div>
        </div>

      ) :
        errorImage ? (
          <div className="mt-5 text-center ">
            <img src={post.errorSmall} alt="404 Not Found" width={300} className="mt-5" />
          </div>
        ) :
          (
            <>
              <div className="p-lg-5 p-md-3 p-3 mt-5">
                <div className="row mt-3 jobdetail-sideLinks">
                  <div className="col-md-6 jobdetail-left">
                    <div className="SingleJob">

                      <div className="job-detail-bgimag">
                        <img
                          src={jobData?.compBackgroundImage}
                          alt="Loading job background image..."

                        />
                      </div>

                      <div className="company-sub-image">
                        <Link to={`/Company/${jobData.compUid}`}>
                          <img
                            src={jobData?.compLogo}
                            alt=""
                            srcset=""
                            // width={150}
                            // height={50}
                            style={{ borderRadius: "50px" }}
                          />
                        </Link>
                      </div>
                      <div className="single-job-main-content p-3 mt-3">
                        <div className="singlejob-cont">
                          <div className="singlejob-header d-flex justify-content-between singlejobnew-header">
                            <div className="lead-product-text f-20 f-600 d-flex flex-column">
                              <Link to={`/Company/${jobData.compUid}`}>
                                <span className="JobTitlenewMain">{jobData.compName}</span>
                              </Link>
                              <div className="JobTitlenew">{jobData?.title}</div>
                              <JobStatusBadges item={jobData} />
                            </div>

                            <div className="lead-product-right">
                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-sharp pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                unsaveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-outlined pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                saveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="singlejob-sub-header d-flex justify-content-between mt-2">
                            <div className="lead-product-text f-12 f-500">
                              {jobData.locationName}{" "}
                              <span className="f-12 f-400">{jobData.cityName}</span>
                            </div>
                            <div className="post-text f-12 f-400">
                              <Tooltip title={moment.utc(jobData?.creationTime).local().format("DD MMM YYYY")} arrow>
                                <span className="f-12 f-400 me-2 ChangeColor">{t("Manage Job.Posted")} {result}</span>
                              </Tooltip>
                              <div className="badge badge-date">
                                {Number(jobData?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(jobData?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${jobData?.expiringInDays} ${t("Manage Job.days Left")}`}
                              </div>
                            </div>
                          </div>

                          <div className="singlejob-sub-header d-flex justify-content-between mt-2">
                            <div className="lead-product-text"></div>
                            <div className="lead-product-text f-12 f-500">
                              {t("Newsfeed.Designation")}
                              <span className="f-12 f-400 ms-2 ChangeColor badge badge-Details">
                                {jobData?.designationName}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="employee-details job-meta-grid mt-4">
                          <div className="employee-custom-details job-meta-chip">
                            <span className="job-meta-label">{t("SearchJob.Work Location")}</span>
                            <span className="job-meta-value">
                              {jobData?.workLocationTypeName || "—"}
                            </span>
                          </div>
                          <div className="employee-custom-details job-meta-chip">
                            <span className="job-meta-label">{t("Newsfeed.Work Level Type")}</span>
                            <span className="job-meta-value">
                              {jobData.workLevelTypeName || "—"}
                            </span>
                          </div>
                          <div className="employee-custom-details job-meta-chip">
                            <span className="job-meta-label">{t("Newsfeed.Job Type")}</span>
                            <span className="job-meta-value">
                              {jobData?.jbTypName || "—"}
                            </span>
                          </div>
                          <div className="employee-custom-details job-meta-chip">
                            <span className="job-meta-label">{t("Newsfeed.Salary Type")}</span>
                            <span className="job-meta-value">
                              {jobData?.salaryDisplay == null
                                ? "N.A"
                                : `${jobData?.salaryDisplay} `}
                            </span>
                          </div>
                        </div>

                        {(jobData?.industryName || jobSkillNames.length > 0) && (
                          <div className="job-master-chips mt-3">
                            {jobData?.industryName && (
                              <span className="badge badge-job badge-job-type">
                                {jobData.industryName}
                              </span>
                            )}
                            {jobSkillNames.slice(0, 8).map((name) => (
                              <span key={name} className="badge badge-job badge-job-role">
                                {name}
                              </span>
                            ))}
                          </div>
                        )}

                        {(jobData?.matchScore != null || jobData?.MatchScore != null) && (() => {
                          const score = Math.round(
                            Number(jobData.matchScore ?? jobData.MatchScore) || 0
                          );
                          const gatePass =
                            jobData.gatePass ?? jobData.GatePass;
                          const reasons =
                            jobData.matchReasons || jobData.MatchReasons || [];
                          const impressions =
                            jobData.impressionCount ?? jobData.ImpressionCount;
                          const tone =
                            score >= 70
                              ? "strong"
                              : score >= 40
                                ? "good"
                                : "low";
                          return (
                            <div className={`job-match-panel job-match-${tone} mt-3`}>
                              <div className="job-match-panel-top">
                                <div className="job-match-score-wrap">
                                  <div
                                    className="job-match-ring"
                                    style={{
                                      background: `conic-gradient(var(--buttonBase) ${score * 3.6}deg, rgba(0,0,0,0.08) 0)`,
                                    }}
                                  >
                                    <div className="job-match-ring-inner">
                                      <span className="job-match-pct">{score}%</span>
                                      <span className="job-match-pct-label">Match</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="job-match-copy">
                                  <div className="job-match-title">
                                    Profile fit for this role
                                  </div>
                                  {gatePass === false ? (
                                    <div className="job-match-gate warn">
                                      Some must-have areas need attention
                                    </div>
                                  ) : (
                                    <div className="job-match-gate ok">
                                      Key requirements look aligned
                                    </div>
                                  )}
                                  {impressions != null && (
                                    <div className="job-match-impressions">
                                      {impressions} impressions
                                    </div>
                                  )}
                                </div>
                              </div>
                              {reasons.length > 0 && (
                                <ul className="job-match-reasons">
                                  {reasons.map((r, i) => (
                                    <li key={i}>{r}</li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          );
                        })()}

                        {recommendTree?.length > 0 && (
                          <div className="job-recommend-panel mt-3">
                            <div className="job-recommend-header">
                              <h3 className="job-recommend-title">Recommended for you</h3>
                            </div>
                            <div className="job-recommend-list">
                              {recommendTree.slice(0, 5).map((item) => {
                                const id = item.entityId ?? item.EntityId;
                                const score = Math.round(
                                  Number(item.score ?? item.Score) || 0
                                );
                                const title =
                                  item.title || item.Title || `Job #${id}`;
                                const company =
                                  item.compName || item.CompName || "";
                                return (
                                  <Link
                                    key={id}
                                    to={`/JobDetail/${id}`}
                                    className="job-recommend-item"
                                  >
                                    <div className="job-recommend-item-main">
                                      <span className="job-recommend-item-title">
                                        {title}
                                      </span>
                                      {company ? (
                                        <span className="job-recommend-item-company">
                                          {company}
                                        </span>
                                      ) : null}
                                    </div>
                                    <span className="job-recommend-item-score">
                                      {score}% match
                                    </span>
                                  </Link>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {screeningQuestions?.length > 0 && jobData?.isApplied !== true && (
                          <div className="mt-3">
                            <h3 className="f-14 f-600">Screening questions</h3>
                            {screeningQuestions.map((q) => {
                              const id = q.jobSqId ?? q.JobSqId;
                              return (
                                <div key={id} className="mb-2">
                                  <label className="f-12 f-500 d-block">
                                    {q.question ?? q.Question}
                                    {(q.mustHave ?? q.MustHave) ? " *" : ""}
                                  </label>
                                  <input
                                    className="form-control form-control-sm"
                                    value={screeningAnswers[id] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setScreeningAnswers((prev) => ({
                                        ...prev,
                                        [id]: value,
                                      }));
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        )}

                        <div className="overview-cont mt-4">
                          <h3 className="f-14 f-600">{t("Newsfeed.Job Description")}</h3>
                          <div
                            className="overviewDescription fst-italic"
                            dangerouslySetInnerHTML={{
                              __html: cleanShortDescription(
                                jobData?.fullDescription
                              ),
                            }}
                          />
                          {/* <p className="f-12 f-400">{jobData.fullDescription}</p> */}
                        </div>
                        <hr />

                        <div className="single-job-bottom-cont d-flex justify-content-between align-items-center">
                          <div className="apply-que-text ChangeTextSize">
                            {jobData?.isOwned !== true && !jobData?.isClosed ? (
                              <h2 className="f-14 f-600 m-0">
                                {t("Newsfeed.Are you Interested in this Jobs")}
                              </h2>
                            ) : jobData?.isOwned === true ? (
                              <div className="badge badge-job1 me-0">
                                {t("Newsfeed.You Owned this company")}
                              </div>
                            ) : null}
                          </div>
                          {jobData && (
                            <DetailJobApply
                              isAppliedByYou={jobData?.isApplied}
                              jobId={jobData?.jobId}
                              getAllJobList={JobDetails}
                              item={jobData}
                              profileConfig={profileConfig}
                              // userPer={userPer}
                              AddUserCcv={AddUserCcv}
                              userCcv={userCcv}
                              allowView={false}
                            />
                          )}
                        </div>
                      </div>

                      <div
                        className={`fixed_Scrollbar-UserDetail-Toolbar fixed_Scrollbar-UserDetail-Toolbar3 ${showToolbar ? "show" : "hide"
                          }`}
                      >
                        <div className="fixed_Scrollbar-UserDetail-ToolbarInner">
                          <div className="fixed_Scrollbar-UserDetail-Toolbar_Details">
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIconBothfixed_Scrollbar-UserDetail-Toolbar_User_Details">
                              <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIcon">
                                <div className={`profileImg fixed_Scroll`}>
                                  <Link to={`/Company/${jobData.compUid}`}>
                                    <img src={jobData?.compLogo} alt="" srcset="" />
                                  </Link>
                                </div>
                              </div>
                              <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details">
                                <Link to={`/Company/${jobData.compUid}`}>
                                  <h4>{jobData.compName}</h4>
                                  <div>{jobData?.title}</div>
                                </Link>
                                <span className="f-12 f-400 d-block ChangeColor">
                                  {jobData.cityName}
                                </span>
                              </div>
                            </div>
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons  fixed_Scrollbar-UserDetail-Toolbar_ButtonsNone">
                              {jobData?.isOwned !== true && jobData?.isClosed ? (
                              <div className="JobDetailsFixedbtn">
                                <div className="badge badge-date">
                                  {t("Manage Job.Closed Job")}
                                </div>
                              </div>
                              ) : jobData?.isOwned !== true && !jobData?.isClosed && (
                              <div className="JobDetailsFixedbtn">
                                <button className="mainBtn appliedBtn"
                                  //  onClick={() =>
                                  //           guestModeData === "true"
                                  //               ? setBookmarkModal(true)
                                  //               : (profileConfig.hasCcv === null || profileConfig.hasCcv !== true) ||
                                  //                  ProfilePercent < 60
                                  //                   ? handleJobApply()
                                  //                   : applyNew()
                                  //       }
                                  onClick={() => {
                                    if (guestModeData === "true") {
                                      return setBookmarkModal(true);
                                    }
                                    if (
                                      profileConfig.hasCcv === null ||
                                      profileConfig.hasCcv !== true ||
                                      ProfilePercent < 60
                                    ) {
                                      return handleJobApply();
                                    }
                                    if (jobData?.isApplied) {
                                      setShowAppliedModal(true);
                                    } else {
                                      return applyNew();
                                    }
                                  }}

                                // onClick={handleJobApply}
                                >{jobData?.isApplied ? (<>
                                  <span className="default-text"><CheckSharpIcon /> {t("Manage Job.Applied")}</span>
                                  <span className="hover-text"><CloseSharpIcon /> {t("Manage Job.Unapply")}</span></>) :
                                  <><SendSharpIcon /> {t("SearchJob.Apply")}</>}</button>
                              </div>
                              )}

                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="job-sticky-meta d-flex align-items-center justify-content-between">
                            <Tooltip title={moment.utc(jobData?.creationTime).local().format("DD MMM YYYY")} arrow>
                              <span className="f-12 f-400 ChangeColor job-sticky-meta-item">{t("Manage Job.Posted")} {result}</span>
                            </Tooltip>
                            <div className="lead-product-text f-12 f-500 job-sticky-meta-item">
                              {t("Newsfeed.Designation")}
                              <span className="f-12 f-400 ms-2 ChangeColor">
                                {jobData?.designationName}
                              </span>
                            </div>
                          </div>
                          <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons  fixed_Scrollbar-UserDetail-Toolbar_ButtonsSmallDevice d-lg-none d-md-none">
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_ButtonsSmallDevice_INNER">
                              {jobData?.isOwned !== true && jobData?.isClosed ? (
                              <div className="JobDetailsFixedbtn">
                                <div className="badge badge-date">
                                  {t("Manage Job.Closed Job")}
                                </div>
                              </div>
                              ) : jobData?.isOwned !== true && !jobData?.isClosed && (
                              <div className="JobDetailsFixedbtn">
                                <button className="mainBtn appliedBtn"
                                  onClick={() =>
                                    guestModeData === "true"
                                      ? setBookmarkModal(true)
                                      : (profileConfig.hasCcv === null || profileConfig.hasCcv !== true) ||
                                        ProfilePercent < 60
                                        ? handleJobApply()
                                        : applyNew()
                                  }
                                // onClick={handleJobApply}
                                >{jobData?.isApplied ? (<>
                                  <span className="default-text"><CheckSharpIcon /> {t("Manage Job.Applied")}</span>
                                  <span className="hover-text"><CloseSharpIcon /> {t("Manage Job.Unapply")}</span></>) :
                                  <><SendSharpIcon /> {t("Manage Job.Apply")}</>}</button>
                              </div>
                              )}

                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-sharp pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                unsaveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}

                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-outlined pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                saveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 jobdetail-right">
                    <FeaturedJobs JobId={JobId} JobDetails={JobDetails} />
                  </div>
                </div>
              </div>
            </>
          )
      }

      {bookmarkModal && <ModalForGuest closeModalData={closeModalData} />}

      {showAppliedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Are you sure want to unapply ?</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>
              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={() => unapplyNew(JobId)}
                >
                  UnApply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal);
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem("hasModalShown");
                      }}
                    >
                      {t("modals.login")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {jobData && jobModalOpen && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}</h6>

                {/* <span
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        setShowResumeModal(false);
                                    }}
                                >
                                    close
                                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setJobModalOpen(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  // onClick={() => {
                  //     userCcv !== "True" && AddUserCcv();
                  // }}
                  >
                    Manage Profile
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        // <JobApplyModals
        //   action={jobData?.isApplied ? 'unapply' : 'apply'}
        //   showApplyModal={jobModalOpen}
        //   onActionClose={()=>setJobModalOpen(true)}
        //   isAppliedByYou={jobData?.isApplied}
        //   jobId={jobData?.jobId}
        //   getAllJobList={JobDetails}
        //   item={jobData}
        //   profileConfig={profileConfig}
        //   // userPer={userPer}
        //   AddUserCcv={AddUserCcv}
        //   userCcv={userCcv}
        // />
      )}
    </>
  );
};

export default JobDetails;
